import Icon from 'component/ui/Icon';
import { IconName } from 'enums/icon';
import React from 'react';

import { Body, Header, Panel } from './styles';

interface Props {
  children: React.ReactNode;
  title: string;
}

const ConfirmDetailsPanel = ({
  children,
  title,
  ...rest
}: Props): React.ReactElement => {
  return (
    <Panel {...rest}>
      <Header>
        <tr>
          <th colSpan={3}>
            <Icon name={IconName.MICROSOFT} />
            <span>{title}</span>
          </th>
        </tr>
      </Header>
      <Body>{children}</Body>
    </Panel>
  );
};

export default ConfirmDetailsPanel;
